import { render, staticRenderFns } from "./CalendarWidth.vue?vue&type=template&id=49673830&"
import script from "./CalendarWidth.vue?vue&type=script&lang=js&"
export * from "./CalendarWidth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports